import { User } from 'entities/User';
import { VerifyEmailCodeRequestDTO } from 'dtos/VerifyEmailCodeRequestDTO';
import { api } from '../api';

type VerifyEmailCodeResponseDTO = {
  user: User;
  token: string;
};

export const verifyEmailCode = async (
  dataRequest: VerifyEmailCodeRequestDTO,
): Promise<VerifyEmailCodeResponseDTO> => {
  const { data } = await api.post('sessions/verifyEmailCode', {
    ...dataRequest,
  });

  return data;
};
